import { render, staticRenderFns } from "./EditInterfaceText.vue?vue&type=template&id=fd7886ea&"
import script from "./EditInterfaceText.vue?vue&type=script&lang=js&"
export * from "./EditInterfaceText.vue?vue&type=script&lang=js&"
import style0 from "./EditInterfaceText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports